module.exports = __webpack_public_path__ + "static/img/1.ba9fd11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ajbz/1.png
// module id = 5PGs
// module chunks = 0